/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionP2P } from './TransactionP2P';
import {
    TransactionP2PFromJSON,
    TransactionP2PFromJSONTyped,
    TransactionP2PToJSON,
} from './TransactionP2P';

/**
 * 
 * @export
 * @interface TransactionsTransactionP2P
 */
export interface TransactionsTransactionP2P {
    /**
     * 
     * @type {Array<TransactionP2P>}
     * @memberof TransactionsTransactionP2P
     */
    value?: Array<TransactionP2P>;
}

/**
 * Check if a given object implements the TransactionsTransactionP2P interface.
 */
export function instanceOfTransactionsTransactionP2P(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TransactionsTransactionP2PFromJSON(json: any): TransactionsTransactionP2P {
    return TransactionsTransactionP2PFromJSONTyped(json, false);
}

export function TransactionsTransactionP2PFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionsTransactionP2P {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : ((json['value'] as Array<any>).map(TransactionP2PFromJSON)),
    };
}

export function TransactionsTransactionP2PToJSON(value?: TransactionsTransactionP2P | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value === undefined ? undefined : ((value.value as Array<any>).map(TransactionP2PToJSON)),
    };
}

